import React from 'react';
import ProjectPage from '../../components/projects/ProjectPage';
import belleMareData from '../../data/projects/bellemare.js';

function BelleMare() {
  return <ProjectPage projectData={belleMareData} />;
}

export default BelleMare;
